<template>
    <div
        :class="{
            'text-area': type === 'text',
            'input-area': type === 'input',
        }"
        class="wrap-el-icon-view"
    >
        <span
            v-if="type === 'text'"
            class="text"
        >{{ showText }}</span>
        <el-input
            v-if="type === 'input'"
            ref="input"
            class="input"
            :value="showText"
            disabled
        />
        <img
            class="icon"
            :src="show ? svgImg.visible : svgImg.invisible"
            @click="toggleShow"
        />
    </div>
</template>

<script>
import { get } from '@lsfe/tools';

export default {
    props: {
        type: {
            type: String,
            default: 'text', // text input
        },
        encryptText: {
            // 密文
            type: String,
            default: '',
        },
        ajax: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showText: '', // 展示的文本
            plainText: '', // 明文
            show: false,
            loading: false,
            svgImg: {
                visible: require('../images/visible.svg'),
                invisible: require('../images/invisible.svg'),
            },
        };
    },
    watch: {
        encryptText(val) {
            this.showText = val;
        },
        showText() {
            this.$nextTick(() => {
                if (this.$refs.input && this.$refs.input.elFormItem) {
                    this.$refs.input.elFormItem.clearValidate();
                }
            });
        },
    },
    created() {
        this.showText = this.encryptText;
    },
    methods: {
        toggleShow() {
            const {
                type, url, params, returnKey, options,
            } = this.ajax();
            if (!url) return;
            const { plainText, loading } = this;
            if (plainText || loading) {
                this.showText = this.plainText;
                return;
            }
            this.loading = true;
            this[type === 'get' ? '$hGet' : '$hPost'](url, params, options)
                .then((res) => {
                    const target = get(res, returnKey);
                    this.plainText = target;
                    this.showText = target;
                    this.show = true;
                    this.loading = false;
                })
                .catch((e) => {
                    this.loading = false;
                    this.$message.error(e.message);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.icon {
    cursor: pointer;
    user-select: none;
    width: 0.8em;
}
.text-area {
    .icon {
        margin-left: 0.5em;
    }
}
.input-area {
    .input {
        flex: 1;
    }
    .icon {
        position: absolute;
        right: 0.5em;
    }
}
.wrap-el-icon-view {
    position: relative;
    display: flex;
    align-items: center;
}
</style>
